import React from "react";
import "./Our_Promise_To_Us.css";
import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";

function OurPromise() {
  return (
    <section className="our-promise">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-2 col-md-2 d-none d-md-block text-start">
            <div className="comma_img">
              <img
                src="/assets/images/about-us/left_comma.png"
                alt="comma"
                className="left_comma"
              />
            </div>
          </div>

          <div className="col-lg-8 col-md-8 col-12 text-center">
            <Common_Title_2 title={"Our Promise To You"} />
            <p className="description">
              Whether you are an athlete looking for recovery, a professional
              seeking deep rest, or someone prioritizing spinal health, our
              mission remains the same:
              <br />
              To provide exceptional sleep solutions that empower you to be your
              best self.
            </p>

            <div className="line"></div>

            <p className="tagline">
              "Majesty: Where world-class science meets the comfort you
              deserve."
            </p>
          </div>

          <div className="col-lg-2 col-md-2 d-none d-md-block text-end">
            <div className="comma_img">
              <img
                src="/assets/images/about-us/right_comma.png"
                alt="comma"
                className="right_comma"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurPromise;
